import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import { API } from "./api";
import axios from "axios";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Footer from "./components/base/Footer";
import Header from "./components/base/Header";
import MainContent from "./components/productView/MainContent";
import DetailedProduct from "./components/productView/DetailedProduct";
import PageNotFound from "./components/pageNotFound/PageNotFound";
import Home from "./components/home/Home";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import CartDesign from "./components/cart/CartDesign";
import OrderSummary from "./components/order/OrderSummary";
import Profile from "./components/profile/Profile";

function App(props) {
  useEffect(() => {
    axios(`${API}products/`).then((res) => {
      props.addProduct(res.data);
    });

    const cart = window.localStorage.getItem("cart")
      ? JSON.parse(window.localStorage.getItem("cart"))
      : [];
    props.addToCartLocal(cart);

    const userDetails = window.localStorage.getItem("userDetails")
      ? JSON.parse(window.localStorage.getItem("userDetails"))
      : [];
    props.addUserDeatilsLocal(userDetails);
  }, [props]);

  return (
    <div className="App">
      <Route path="/" render={(props) => <Header {...props} />} />

      <Switch>
        <Route exact path="/" render={(props) => <Home {...props} />} />
        <Route
          path="/products/search/:querry"
          render={(props) => <MainContent {...props} />}
        />
        <Route path="/login" render={(props) => <Login {...props} />} />
        <Route path="/signup" render={(props) => <Signup {...props} />} />
        <Route path="/cart" render={(props) => <CartDesign {...props} />} />
        <Route path="/order" render={(props) => <OrderSummary {...props} />} />
        <Route path="/profile" render={(props) => <Profile {...props} />} />
        <Route
          path="/detail/:id"
          render={(props) => <DetailedProduct {...props} />}
        />
        <Route path="" render={(props) => <PageNotFound {...props} />} />
      </Switch>

      <Route path="/" render={(props) => <Footer {...props} />} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProduct: (val) => dispatch({ type: "ADD_PRODUCTS", payload: val }),
    addToCartLocal: (val) =>
      dispatch({ type: "ADD_FROM_LOCALSTORAGE", payload: val }),
    addUserDeatilsLocal: (val) =>
      dispatch({ type: "ADD_USER_DETAILS_FROM_LOCALSTORAGE", payload: val }),
  };
};
export default connect(null, mapDispatchToProps)(App);
